module.exports = __webpack_public_path__ + "img/pexels-tom-fisk-3856433.204e4e25.jpg";